<template>
  <div class="app">
    <iframe id="room_if" style="display:none;z-index:1000;position:absolute;width:100%;height:100%;top:0;left:0;border:none;background-color:#1a1a1d;"> </iframe>
    <Navigation />
    <b-alert
      class="position-fixed global-notification text-center"
      style="margin:30% 0"
      :show="fatal.alertCountDown" variant="danger">
      {{ fatal.alertMessage }}
    </b-alert>
    <b-toaster style="" name="apptoast" style="position:fixed;top:50px;left:1rem;">
    </b-toaster>
    <div class="page">
      <transition name="fade">
        <router-view />
      </transition>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navigation from "@/components/Navigation.vue";

import "./assets/css/main.scss";
import { sync } from "vuex-pathify";
import store from "./store";
import vx_api from "./vuemix";

export default {
  components: {
    Navigation
  },
  created() {
    let vue = this;
    window.issue_restart = function(msg) {
      vue.fatal = { alertCountDown:60, alertMessage: msg };
      /* Delay browser launch to let them read the message */
      setTimeout(function() {
        vue.mydevice.open_native_url("https://videocafe.live/download.html");
      }, 3000);
      setTimeout(function() { window.close(); },7000);
    }
    if (window.do_issue_restart) {
       window.issue_restart(window.do_issue_restart);
    }
    window.show_notification = function(msg,variant,sec) {
       if (vue.disable_notifications) { return; }
       vue.show_notification(msg, {
         variant: variant,
         delay: 1000*sec,
       });
    }
    vue.set_nav(vue.$router.currentRoute);
    vue.loadPast();
    vue.set_background();
  },
  watch: {
    $route(to, from) {
      // eslint-disable-next-line
      //console.log("watch:" + from.name+JSON.stringify(from.params) + " " + to.name+JSON.stringify(to.params));
      //this.nav_view_title = this.$parent.viewTitle;
      this.cur_room_dname = "";
      this.set_nav(to);
    }
  },
  methods: {
    close_notification: function(id,opt={}) {
      let vue = this;
      vue.$bvToast.hide(id);
    },
    show_notification: function(m,opt={}) {
      let vue = this;
      let variant = opt.variant || "danger";
      let delay = opt.delay;
      let x = m;
      vue.notify_count = (vue.notify_count || 1) + 1;
      if (!delay) {
        if (variant == "success") { delay = 3000; }
        else if (variant == "warning" || variant == "info") { delay = 5000; }
        else { delay = 10000; }
      }
      if (opt.url) {
        x = vue.$createElement('div',{}, [
          vue.$createElement('span',{
            style:'font-weight:bold;',
          }, m),
          vue.$createElement('a',{
            style:'font-weight:bold;margin:0 0.5rem;',
            domProps:{href:opt.url,target:"_blank"}},
            (opt.urlText || "Link")),
         ]
        );
      } else if (opt.btn) {
        opt.btnArgs = opt.btnArgs || {};
        opt.btnArgs.id = "app-toast-"+vue.notify_count;
        x = vue.$createElement('div',{}, [
          vue.$createElement('div',{
            style:'font-weight:bold;',
          }, m),
          vue.$createElement('button',{
            class: 'btn btn-primary btn-sm',
            style:'font-size: 0.7rem; margin: 0 0.2rem; padding:0 0.2rem;',
            domProps:{type:"button",
                      onclick:opt.btnAction,
                      btnArgs: JSON.parse(JSON.stringify(opt.btnArgs)),
                      },
            }, (opt.btnText || "Click")),
         ]
        );
      }
      if (opt.uni) {
        vue.toastmap = vue.toastmap || {};
        let oldid = vue.toastmap[opt.uni];
        if (oldid) {
           vue.close_notification(oldid);
        }
        vue.toastmap[opt.uni] = "app-toast-"+vue.notify_count;
      }
      vue.$bvToast.toast([
           vue.$createElement('div',{style:'display:none'})
        ], {
        id: "app-toast-"+vue.notify_count,
        title: x,
        variant: variant,
        autoHideDelay: delay,
        appendToast: true,
        toaster: "apptoast",
      });
    },
    set_background: function() {
      let vue = this;
      $("body").css("background-color","#1a1a1d");
      $("body").css("background-image", "");
    },
    set_room_background: function(imgurl) {
      let vue = this;
      if (!vue.mydevice.set_background) {
        /* Transparent, No Image */
        $("body").css("background-color","rgba(0,0,0,0)");
        $("body").css("background-image", "");
      } else if (imgurl) {
        // background-repeat: repeat space;
        $("body").css("background-color","#1a1a1d");
        $("body").css("background-image", "url("+imgurl+")");
      } else {
        $("body").css("background-color","#1a1a1d");
        $("body").css("background-image", "");
      }
    },
    set_nav: function(cr) {
      let vue = this;
      let x = {};
      vue.nav_title = "";
      x.dropdown = vue.isAuth();
      x.rname = cr.name;
      switch(cr.name) {
        case "login":
        case "register":
        case "preset":
          break;
        case "guest":
          x.nav = false;
          break;
        case "systest":
          x.nav = true;
          x.dropdown = true;
          if (vue.currentUser.nick && vue.currentUser.nick != "-please-set-") {
            x.myroom = true;
          }
          x.home = true;
          break;
        case "download":
          if (vue.currentUser.role == "guest") {
            x.nav = true;
            x.login = true;
          } else {
            x.nav = true;
            x.goloc_cont = true;
          }
          break;
        case "stat-viewer":
          x.nav = true;
          break;
        case "settings":
          x.nav = true;
          x.dropdown = false;
          x.stats = true;
          if (!vue.mydevice.multi_window) {
            x.back_toroom = true;
          }
          break;
        case "schedule":
          x.nav = true;
          x.home = true;
          x.dropdown = true;
          x.back_toroom = false;
          break;
        case "stats":
          x.nav = true;
          x.dropdown = false;
          x.back_settings = true;
          break;
        case "account":
          x.nav = true;
          x.back_hist = true;
          break;
        case "share":
          break;
        case "home":
          x.nav = true;
          x.room_search = true;
          if (vue.mydevice.multi_window &&
              vue.currentUser.adm_acc) {
            x.adm = true;
          }
          if (vue.currentUser.nick && vue.currentUser.nick != "-please-set-") {
            x.myroom = true;
          }
          if (vue.mydevice.multi_window && !vx_no_cookies(window.vx)) {
            x.menu_newwindow = true;
          }
          break;
        case "room":
          x.nav = true;
          if (!vue.$router.from_bcast) {
            x.home = true;
          }
          x.title = true;
          if (vue.mydevice.kvm_supported) {
            x.kvm = true;
          }
          if (!vue.mydevice.is_mobile) {
            x.ss = true;
          }
          if (vue.mydevice.can_capture) {
            x.cap_panel = true;
          } else {
            x.cap_panel_download = true;
          }
          x.settings = true;
          x.unmute = true;
          if (vue.mydevice.start_mirror) {
             x.mirror = true;
          }
          if (vue.mydevice.aarec_start) {
             x.aarec = true;
          }
          if (vue.currentUser.adm_acc || (vx && vx.debug)) {
            x.menu_debug = true;
          }
          x.menu_arc = true;
          if (vue.mydevice.multi_window && !vx_no_cookies(window.vx)) {
            x.menu_newwindow = true;
          }
          break;
        case "room-camonly":
          x.nav = true;
          x.title = true;
          //x.ss = true;
          if (vue.mydevice.can_capture) {
            x.cap_panel = true;
          } else {
            x.cap_panel_download = true;
          }
          x.unmute = true;
          x.menu_debug = true;
          break;
        case "chat":
          if (!vue.mydevice.multi_window) {
            x.nav = true;
            x.dropdown = false;
          } else if (!window.opener) {
            x.nav = true;
          }
          if (window.frameElement && window.frameElement.id == "room_if") {
             x.close_iframe = true;
          }
          break;
        case "mychat":
          if (!vue.mydevice.multi_window) {
            x.nav = true;
            x.dropdown = false;
          }
          if (window.frameElement && window.frameElement.id == "room_if") {
             x.close_iframe = true;
          }
          break;
        case "arch":
          x.nav = true;
          //if (vue.isAuth()) {
          //  x.home = true;
          //}
          break;
        case "archss":
          break;
        case "arc":
          x.nav = true;
          x.home = true;
          x.unmute = true;
          if (vue.mydevice.in_iframe) {
            x.back_hist = true;
          }
          break;
        case "cast":
          x.nav = true;
          x.unmute = true;
          //if (vue.currentUser.role == "guest") {
          //   x.login = true;
          //}
          break;
        case "admuser":
          x.nav = true;
          x.home = true;
          x.adm_acc =  vue.currentUser.adm_acc || false;
          x.adm_users = vue.currentUser.adm_users || false;
          break;
        case "admacc":
          x.nav = true;
          x.home = true;
          x.adm_acc =  vue.currentUser.adm_acc || false;
          x.adm_users = vue.currentUser.adm_users || false;
          break;
        case "quiz":
          x.nav = true;
          break;
        case "hall":
          x.nav = true;
          x.myroom = true;
          x.settings = true;
          break;
        case "truck":
          x.nav = true;
          break;
        case "land":
          x.nav = true;
          if (vue.isAuth()) {
            x.home = true;
          } else {
            x.login = true;
          }
          break;
        case "eventlist":
        case "event":
        case "sessions":
        case "speakers":
        case "booths":
        case "networking":
          x.nav = true;
          break;
      }
      Object.keys(vue.nav).forEach(function(k) {
        vue.nav[k] = x[k] || false;
        //if (x[k]) console.log("NAV:"+k);
      });
    },
    regCastAskCb: function(cb) {
      this.nav.cast_ask_cb = cb;
    },
    setAudView: function(enable) {
      if (enable) {
        this.nav.aud_search = true;
        this.nav.title = false;
      } else {
        this.nav.aud_search = false;
        this.nav.title = true;
      }
    },
    amStreaming: function() {
      if (this.mydevice.capture_state != "off") {
        return 1;
      }
      /* state = off but is_capturing true means another window is doing it */
      if (this.mydevice.is_capturing) {
        return 2;
      }
      return 0;
    },
    showPanelManual: function() {
      let vue = this;
      if (document.hidden) { return; }
      /* This ~should~ always be false. However, there seems to
       *   be a rare corner case in prod builds where the set-to-true
       *   event does not propogate. Toggling is a symtomatic fix.
       *   In the errant case, the first click will change to false
       *   and any subsequent click will open as expected. */
      this.show_panel = !this.show_panel;
      if (vx && vx.debug) { console.log("showPanelManual",this.show_panel); }
    },
    showPanel: function() {
      let vue = this;
      if (document.hidden) { return; }
      this.show_panel = true;
      if (vx && vx.debug) { console.log("showPanel"); }
    },
    hidePanelManual: function() {
      let vue = this;
      if (document.hidden) { return; }
      /* This ~should~ always be true. However, there seems to
       *   be a rare corner case in prod builds where the set-to-true
       *   event does not propogate. Toggling is a symtomatic fix.
       *   In the errant case, the first click will change to false
       *   and any subsequent click will open as expected. */
      this.show_panel = !this.show_panel;
      if (vx && vx.debug) { console.log("hidePanelManual",this.show_panel); }
    },
    hidePanel: function() {
      //store.set("showCapturePanel", false);
      this.show_panel = false;
      if (vx && vx.debug) { console.log("hidePanel"); }
    },
    dc2name(dc) {
      if (dc == "stage") {
          return {n:"San Jose", c:"USA", r:"USA West"};
      } else if (dc.indexOf("lon") == 0) {
          return {n:"London", c:"England", r:"Europe West"};
      } else if (dc.indexOf("che") == 0) {
          return {n:"Mumbai", c:"India", r:"India"};
      } else if (dc.indexOf("hkg") == 0) {
          return {n:"Hong-Kong", c:"China", r:"Asia East"};
      } else if (dc.indexOf("sjc") == 0) {
          return {n:"San Jose", c:"USA", r:"USA West"};
      } else if (dc.indexOf("wdc") == 0) {
          return {n:"Virginia", c:"USA", r:"USA East"};
      } else if (dc.indexOf("fra") == 0) {
          return {n:"Frankfurt", c:"Germany", r:"Europe East"};
      }
      return {n:dc, c:"", r:dc};
    },
    goRoomArchive() {
      let vue = this;
      if (!vue.mydevice.in_iframe) {
        let hash = vue.$router.resolve({
            name: 'arc',
        }).href;
        // Build URL to make sure we do not carry over the rlded flag
        let url = "//"+window.location.host+window.location.pathname+hash;
        window.open(url, 'roomlib', 'width=750,height=600');
      } else {
        vue.$router.push({name: 'arc'});
      }
    },
    goUserArchive() {
      let vue = this;
      let url = vue.$router.resolve({
          name: 'arc',
          params: {acc: vue.currentUser.acc,
                   uid: vue.currentUser.nick}
      }).href;
      window.open(url, 'yourlib', 'width=750,height=600');
    },
    goAccount() {
      this.$router.push({name: 'account',
                         params: {acc: this.currentUser.acc,
                                  uid: this.currentUser.nick} });
    },
    isOpenChat(acc,room) {
      let url;
      if (!acc || !room) {
         return;
      } else {
         url = this.$router.resolve({name: 'chat',
                                     params: {acc: acc, uid: room}
                                     }).href;
         //console.log(url,document.baseURI);
         url = new URL(url,document.baseURI);
      }
      return window.is_url_open(url);
    },
    openRoom(acc,room) {
      let url;
      if (!acc || !room) {
         return;
      } else {
         url = this.$router.resolve({name: 'room',
                                     params: {acc: acc, uid: room}
                                     }).href;
      }
      if (am_in_cors_iframe()) {
         let cfg = {creds:{}};
         cfg.provider = "guest";
         cfg.path = url.split("#")[1];
         cfg.creds.me = (window.vx.user.creds.me+"&guid="+
                         window.vx.user.id);
         /* When target page opens, router appears to, in effect, call
          *   encodeURIComponent twice thus we need to call it on the
          *   'cfg' below. */
         url = "#/bounce/"+encodeURIComponent(b64_encode(JSON.stringify(cfg)));
      }
      //console.log("URL: https://devdev.staging.vuemix.com:8888/mm/"+url);
      window.open(url, '_blank');
    },
    openChat(acc,room) {
      let url;
      if (!acc || !room) {
         return;
      } else {
         url = this.$router.resolve({name: 'chat',
                                     params: {acc: acc, uid: room}
                                     }).href;
      }
      if (am_in_cors_iframe()) {
         let cfg = {creds:{}};
         cfg.provider = "guest";
         cfg.path = url.split("#")[1];
         cfg.creds.me = (window.vx.user.creds.me+"&guid="+
                         window.vx.user.id);
         let len = Math.trunc(Math.random() * 8);
         cfg.x = "z";
         while (len > 0) {
           cfg.x += "a";
           --len;
         }
         /* When target page opens, router appears to, in effect, call
          *   encodeURIComponent twice thus we need to call it on the
          *   'cfg' below. */
         url = "#/bounce/"+encodeURIComponent(b64_encode(JSON.stringify(cfg)));
         if (vx && vx.debug) { console.log("open",cfg.x,url); }
      }
      if (this.mydevice.multi_window) {
        window.open_if_not(url, '_blank','width=512,height=640,toolbar=0,location=0,menubar=0');
      } else {
        $("#room_if")[0].src = url;
        $("#room_if").show();
      }
    },
    openHelp() {
      this.mydevice.open_native_url("https://videocafe.live/resources.html");
    },
    goRegister() {
      this.$router.push({name: 'register'});
    },
    goBack() {
      if (window.history.length > 1) {
        window.history.back();
      } else {
        this.goHome();
      }
    },
    goHome() {
      this.$router.push({ name: 'home' });
    },
    goEvent() {
      this.$router.push({ name: 'event', params:{id:this.eventid}});
    },
    goDownload() {
      this.$router.push({name: "download"});
    },
    goSettings() {
      this.$router.push({ name: 'settings' });
    },
    goLogin() {
      this.$router.push({ name: 'login' });
    },
    goStatViewer() {
      this.$router.push({ name: 'stat-viewer' });
    },
    goStats() {
      this.$router.push({ name: 'stats' });
    },
    getGoLocOrHome: function() {
      if (window.continue_to_page(this.$router,true)) {
         return;
      }
      this.$router.push({ name: 'home' });
    },
    goMyRoom() {
      if (!this.currentUser.nick) { return; }
      this.$router.push({ name: 'room',
                          params: { acc: this.currentUser.acc,
                                    uid: this.currentUser.nick } });
    },
    getPrvPath() {
      return window.getLocal("vx_router_back");
    },
    getPrvPathOrHome() {
      let p = this.getPrvPath();
      if (p) return p;
      return "home";
    },
    getToRoom() {
      let room = this.$router.currentRoute.params.uid;
      if (!room) { return "home"; }
      return { name: 'room', params: { uid: room } };
    },
    isGuest: function() {
      let vue = this;
      if (vue.currentUser.role == "guest") {
        return true;
      }
      return false;
    },
    isAuth: function() {
      let vue = this;
      if (vue.currentUser.role === "authenticatedUser" ||
          vue.currentUser.role == "authenticatedUserUN") {
        return true;
      }
      return false;
    },
    isAuthUN: function() {
      let vue = this;
      if (vue.currentUser.role == "authenticatedUserUN") {
        return true;
      }
      return false;
    },
    signUserOut: function(e, msg, variant) {
      let vue = this;
      if (!vue.isAuth()) {
        window.event_to_parent({type:"noauth"});
      }
      eraseLocal("vx_cred_me");
      vue.leaveMsgText = "";
      vue.mydevice.stop_capture();
      vue.mydevice.stop_share({logout:true});
      window.close_all_opened();
      vxslog({p:"-",a:"signout"});
      vx_api
       .signOut(window.vx)
       .then(data => {
         // eslint-disable-next-line
         console.log("Signed Out");
         window.event_to_parent({type:"signout"});
         //variant
         vue.$user.set({
           role: "guest"
         });
         store.set("room", {});
         if (e != "quiet") {
           msg && vue.show_notification(msg,{});
           window.close();
           if (vue.$router.currentRoute.path != "/login") {
             vue.$router.push({name: 'login'});
           }
         }
       }).catch(e => {
         window.event_to_parent({type:"signout"});
         vue.$user.set({
           role: "guest"
         });
         if (e != "quiet") {
           store.set("room", {});
           window.close();
           if (vue.$router.currentRoute.path != "/login") {
             vue.$router.push({name: 'login'});
           }
         }
       });
       window.vxResetAll();
    },
    closeIframe: function() {
      let vue = this;
      if (vue.mydevice.src_iframe) {
        $(vue.mydevice.src_iframe).hide();
        vue.mydevice.src_iframe.src = "";
      }
    },
    showTrackMessage: function() {
      let shown = window.getLocal("shown_tm") || false;
      if (!shown) {
        try {
          window.localStorage.getItem("shown_tm")
        } catch {
          /* If local-storage is inaccessible then there
             we are in 3rdParty mode and there are no
             cookies */
          window.setLocal("shown_tm",true);
          return;
        }
      }
      if (!shown && this.mydevice.tracking_setting) {
        this.has_shown_tracking_msg = true;
        if (this.mydevice.tracking_setting == "none") {
           this.show_msg_no_tracking = true;
        } else {
           this.show_msg_tracking = true;
        }
      }
    },
    dismissTrackMessage: function() {
      this.show_msg_no_tracking = false;
      this.show_msg_tracking = false;
      window.setLocal("shown_tm",true);
    },
    showCamBtn: function(show_cam_btn,video_off) {
      this.show_cam_btn = show_cam_btn || false;
      this.video_off = video_off || false;
    },
    clearSelectedVideo: function() {
       let vue = this;
       window.eraseLocal("vx_vgroup");
       vue.selected_video_group = null;
       vue.selected_video_source = null;
    },
    update_video_max: function(m) {
      this.video_max = (0|m);
      window.setLocal("vx_video_max",this.video_max);
    },
    refreshAVSources: function(rav) {
      let vue = this;
      rav = rav || {};
      rav.notify = rav.notify || function(dur,msg) {
        console.warn("refreshAVSources:"+msg);
      };
      /* Streaming owned by different tab? */
      if (vue.amStreaming() == 2) { return; }
      /* Disallow changes during screen share */
      if (vue.mydevice.share_state != "off") { return; }

      /* Refreshing while hidden often results in denied
       *   access to devices, particularly on mobile */
      if (document.hidden) { return; }
      /* Disable use of 'video_max' since the UI is disabled
       *  use of stored value needs to be used if UI returns.
       */
      //vue.video_max = (0|window.getLocal("vx_video_max"));
      //if (!vue.video_max) {
         if (vue.mydevice.pt_can_send) {
           vue.video_max = 3;
         } else {
           vue.video_max = 2;
         }
         window.setLocal("vx_video_max",vue.video_max);
      //}
      vue.avrefresh_in_progress = true;
      if (vue.mydevice.get_av_groups) {
         let vgroup = window.getLocal("vx_vgroup");
         let agroup = window.getLocal("vx_agroup"+vue.sel_audio_idx);
         vue.selected_video_group = null;
         vue.selected_video_source = null;
         vue.selected_audio_group[vue.sel_audio_idx] = null;
         let opt = {filter:true};
         opt.enumerate_audio = vue.enumerate_audio ? true : false;
         opt.enumerate_video = vue.enumerate_video ? true : false;
         vue.mydevice.get_av_groups(opt, function(srcs) {
            vue.avrefresh_in_progress = false;
            vue.has_enumerated_video = vue.enumerate_video;
            vue.has_enumerated_audio = vue.enumerate_audio;
            vue.video_groups = [];
            if (srcs.ve && srcs.ve.length > 0) {
               rav.notify(
                 'err',
                 `You have denied this website access to your ${srcs.ve[0].n}.`,
                 {url: vue.mydevice.help_allowcam, urlText: "How To Fix"}
               );
            }
            if (srcs.audio.length > 0 && srcs.video.length > 0) {
              vue.video_enabled = true;
              srcs.video.forEach(function(s) {
                if (s.match(/display capture/i)) {
                  vue.video_groups.push({value:s,text:"Desktop",x:1,prefix:"h"});
                } else if (s.match(/video capture/i)) {
                  vue.video_groups.push({value:s,text:"Cameras",x:0});
                } else {
                  vue.video_groups.push({value:s,text:s,x:3});
                }
                if (vgroup == s) {
                   vue.selected_video_group = s;
                }
              });
              vue.video_groups = vue.video_groups.sort(function(a,b) {
                return a.x - b.x;
              });
              if (!vue.selected_video_group) {
                vue.video_groups.forEach(function(x) {
                   if (x && x.text.match(/camera/i)) {
                     vue.selected_video_group = x.value;
                   }
                });
                if (!vue.selected_video_group &&
                    (!srcs.ve || !srcs.ve.length)) {
                  rav.notify(
                    'err',
                    "You don't appear to have a camera. Select camera/video config below."
                  );
                }
              }
              vue.onVideoGroupChange(true);
            } else {
              vue.selected_video_group = null;
              vue.video_enabled = false;
            }

            vue.audio_groups = null;
            if (srcs.ae && srcs.ae.length > 0) {
               rav.notify(
                 'err',
                 `You have denied this website access to your ${srcs.ae[0].n}.`,
                 {url: vue.mydevice.help_allowcam, urlText: "How To Fix"}
               );
            }
            if (srcs.audio.length > 0) {
              vue.audio_groups = [];
              if (vue.sel_audio_idx) {
                vue.audio_groups.push({value:"none",text:"None / Silent"});
              }
              srcs.audio.forEach(function(s) {
                vue.audio_groups.push({value:s,text:s});
                if (agroup == s) {
                   vue.selected_audio_group[vue.sel_audio_idx] = s;
                }
              });
              if (vx && vx.debug) {
                 console.log("sag "+vue.sel_audio_idx+" "+
                             JSON.stringify(vue.selected_audio_group));
              }
              if (!vue.selected_audio_group[vue.sel_audio_idx]) {
                if (vue.sel_audio_idx == 0) {
                  /* Some real source should exist for primary */
                  vue.audio_groups.forEach(function(x) {
                     if (x && x.text.match(/micro/i)) {
                       vue.selected_audio_group[vue.sel_audio_idx] = x.value;
                     }
                  });
                  if (!vue.selected_audio_group[vue.sel_audio_idx] &&
                      (!srcs.ae || !srcs.ae.length)) {
                    rav.notify(
                      'err',
                      "You don't appear to have a microphone. Select microphone/audio config below."
                    );
                  }
                } else {
                  vue.audio_groups.forEach(function(x) {
                     if (x && x.text.match(/silent/i)) {
                       vue.selected_audio_group[vue.sel_audio_idx] = x.value;
                     }
                  });
                }
              }
              vue.onAudioGroupChange(true,rav);
            } else {
              vue.selected_audio_group[vue.sel_audio_idx] = null;
            }

            if (srcs.output.length > 0) {
              srcs.output.forEach(function(s) {
                vue.selected_speaker_group = s;
              });
              vue.onSpeakerGroupChange(true,rav);
            }

            rav.cb && rav.cb();
         });
      }
    },
    onVideoGroupChange: function(fromRefresh) {
      // eslint-disable-next-line
      if (vx && vx.debug) { console.log("onVideoGroupChange"); }
      let vue = this;
      let g = vue.selected_video_group;
      vue.selected_video_prefix = "d"; /* default */
      if (g && vue.video_groups) {
        vue.video_groups.forEach(function(grp) {
          if (grp.value == g && grp.prefix) {
             vue.selected_video_prefix = grp.prefix;
          }
        });
      }
      window.setLocal("vx_vgroup",g);
      let vsource = window.getLocal("vx_vsource");
      vue.selected_video_source = null;
      vue.mydevice.get_av_sources("video",g,function(srcs) {
         vue.video_sources = [];
         if (srcs.length > 0) {
           srcs.forEach(function(s) {
             let h = {value:s.i, text:s.n};
             vue.video_sources.push(h);
             if (vsource == (""+h.value+","+h.text)) {
               vue.selected_video_source = h.value;
             }
           });
           if (vue.selected_video_source === null &&
               !vue.isFakeCamera(vue.video_sources[0].value)) {
             vue.selected_video_source = vue.video_sources[0].value;
           }
           vue.onVideoSourceChange(fromRefresh);
         }
      });
    },
    isFakeCamera: function(val) {
      let vue = this;
      if (val && val.indexOf("enumerate-camera") >= 0) {
         return true;
      }
      return false;
    },
    enableVideoEnum: function(cb) {
      let vue = this;
      if (vue.enumerate_video) { return; }
      /* Only take action if newly enumerating */
      vue.enumerate_video = true;
      vue.video_sources = [];
      cb && cb();
    },
    onVideoSourceChange: function(fromRefresh,rav) {
      // eslint-disable-next-line
      if (vx && vx.debug) { console.log("onVideoSourceChange:"+this.selected_video_source+" "+this.selected_video_prefix); }
      let vue = this;
      if (!vue.selected_video_source) { return; }
      if (vue.isFakeCamera(vue.selected_video_source)) {
        vue.enableVideoEnum(function() {
          vue.refreshAVSources(rav);
        });
        return;
      }
      vue.video_sources.forEach(function(s) {
        if (s.value == vue.selected_video_source) {
          window.setLocal("vx_vsource",(""+s.value+","+s.text));
        }
      });
      // vue.update_video_rc(); // FIXME
      if (vue.mydevice.change_vid_src) {
         vue.mydevice.change_vid_src({
           sel_video: vue.selected_video_source,
         }, function(status) {
           if (status == "ok") { return; }
           /* User likely denied access to device. Clear selection so
            * that the "Join with Video" will disappear. */
           vue.selected_video_source = null;
         });
      }
      if (vue.video_enabled && vue.mydevice.has_preview) {
          if (vue.selected_video_group != vue.mydevice.preview_video_group ||
              vue.selected_video_source != vue.mydevice.preview_video_source) {
             vue.mydevice.start_preview(
               {video: vue.selected_video_source},
               function(err,data) {
                 if (err) {
                   // eslint-disable-next-line
                   console.log("Render Error");
                 } else {
                   // eslint-disable-next-line
                   if (vx && vx.debug) { console.log("Render Success"); }
                   window.vx_pvw_img("#pvw_self", 640, 360, {delay: 250});
                   vue.mydevice.preview_video_group = vue.selected_video_group;
                   vue.mydevice.preview_video_source = vue.selected_video_source;
                }
               });
          } else {
            window.vx_pvw_img("#pvw_self", 640, 360, {delay: 250});
          }
      }
    },
    onAudioGroupChange: function(fromRefresh,rav) {
      // eslint-disable-next-line
      let vue = this;
      let g = vue.selected_audio_group[vue.sel_audio_idx];
      if (vx && vx.debug) { console.log("onAudioGroupChange",g); }
      window.setLocal("vx_agroup"+vue.sel_audio_idx,g);
      if (vue.sel_audio_idx && g == "none") {
         /* Fake no-background-audio group */
         vue.audio_sources = [{value:"--noaudio--", text:"--"}];
         vue.selected_audio_source[vue.sel_audio_idx] = "--noaudio--";
         vue.onAudioSourceChange(fromRefresh,rav);
         return;
      }
      let asource = window.getLocal("vx_asource"+vue.sel_audio_idx);
      vue.selected_audio_source[vue.sel_audio_idx] = null;
      vue.mydevice.get_av_sources("audio",g,function(srcs) {
         if (srcs.length > 0) {
           vue.audio_sources = [];
           srcs.forEach(function(s) {
             let h = {value:s.i, text:s.n};
             //if (vue.sel_audio_idx) {
             //  /* non-primary audio should not match primary */
             //  console.log("sdup? "+vue.selected_audio_group[0]+":"+
             //              vue.selected_audio_source[0]+" == "+
             //              vue.selected_audio_group[vue.sel_audio_idx]+":"+
             //              h.value);
             //  if ((vue.selected_audio_group[vue.sel_audio_idx] ==
             //          vue.selected_audio_group[0]) &&
             //      (h.value == vue.selected_audio_source[0])) {
             //      return;
             //  }
             //}
             //console.log("PUSH ",JSON.stringify(h));
             vue.audio_sources.push(h);
             if (asource == (""+h.value+","+h.text)) {
               vue.selected_audio_source[vue.sel_audio_idx] = h.value;
             }
           });
           if (vue.selected_audio_source[vue.sel_audio_idx] === null &&
               !vue.isFakeMic(vue.audio_sources[0].value)) {
             vue.selected_audio_source[vue.sel_audio_idx] =
                 vue.audio_sources[0].value;
           }
           vue.onAudioSourceChange(fromRefresh,rav);
         }
      });
    },
    isFakeMic: function(val) {
      let vue = this;
      if (val && val.indexOf("enumerate-mic") >= 0) {
         return true;
      }
      return false;
    },
    enableAudioEnum: function(cb) {
      let vue = this;
      if (vue.enumerate_audio) { return; }
      /* Only take action if newly enumerating */
      vue.enumerate_audio = true;
      vue.audio_sources = [];
      cb && cb();
    },
    onAudioSourceChange: function(fromRefresh,rav) {
      let vue = this;
      // eslint-disable-next-line
      if (vx && vx.debug) {
         console.log("onAudioSourceChange:"+
                     this.selected_audio_source[vue.sel_audio_idx]);
      }
      if (vue.isFakeMic(vue.selected_audio_source[0])) {
        vue.enableAudioEnum(function() {
          vue.refreshAVSources(rav);
        });
        return;
      }
      vue.audio_sources.forEach(function(s) {
        if (s.value == vue.selected_audio_source[vue.sel_audio_idx]) {
          window.setLocal("vx_asource"+vue.sel_audio_idx,(""+s.value+","+s.text));
        }
      });
      if (!fromRefresh && vue.mydevice.change_aud_src) {
         vue.mydevice.change_aud_src({
           sel_idx: vue.sel_audio_idx,
           sel_audio: vue.selected_audio_source[vue.sel_audio_idx],
         }, function(err) {
           if (!err) { return; }
           rav.notify('err',err);
           /* For Background Music revert back to none */
           vue.selected_audio_group[vue.sel_audio_idx] = null;
           vue.selected_audio_source[vue.sel_audio_idx] = null;
           window.eraseLocal("vx_agroup"+vue.sel_audio_idx);
           window.eraseLocal("vx_asource"+vue.sel_audio_idx);
         });
      }
    },
    onSpeakerGroupChange: function(fromRefresh,rav) {
      let vue = this;
      let source = window.getLocal("vx_ssource");
      let g = vue.selected_speaker_group;
      if (vx && vx.debug) { console.log("onSpeakerGroupChange",g); }
      vue.selected_speaker_source = null;
      vue.mydevice.get_av_sources("speaker",g,function(srcs) {
         if (!srcs.length) { return; }
         vue.speaker_sources = [];
         srcs.forEach(function(s) {
           let h = {value:s.i, text:s.n};
           vue.speaker_sources.push(h);
           if (source == (""+h.value+","+h.text)) {
             vue.selected_speaker_source = h.value;
           }
         });
         if (vue.selected_speaker_source === null) {
           vue.selected_speaker_source =
               vue.speaker_sources[0].value;
         }
         vue.onSpeakerSourceChange(fromRefresh,rav);
      });
    },
    onSpeakerSourceChange: function(fromRefresh,rav) {
      let vue = this;
      // eslint-disable-next-line
      if (vx && vx.debug) {
         console.log("onSpeakerSourceChange:"+
                     this.selected_speaker_source);
      }
      vue.speaker_sources.forEach(function(s) {
        if (s.value == vue.selected_speaker_source) {
          window.setLocal("vx_ssource",(""+s.value+","+s.text));
        }
      });
      if (vue.mydevice.change_spk_src) {
         /* We need to call this both to change speaker AND to
          *  determine if this browser even supports the ability.
          *  A callback, ok or error, implies feature support */
         vue.mydevice.change_spk_src({
           sel_speaker: vue.selected_speaker_source,
         }, function(err) {
           vue.enable_speaker_select = true;
         });
      }
    },
    slSignIn: function(teamid) {
      let vue = this;
      let host = window.location.host;
      let resume = window.location.pathname;
      let base = "https://mapp.vuemix.com";
      if (host.indexOf("staging.vuemix.com") >= 0) {
        base = "https://app.staging.vuemix.com";
      }
      let dm = host.indexOf(".vuemix.com");
      if (dm > 0) {
        host = host.substring(0, dm);
      }
      let LoginURL =
         base +
         "/mm/loginredirect.html?action=slack_auth&teamid="+teamid+
         "&acc=" + host + "&resume=" +
         encodeURIComponent(resume + "#/login");
      window.location.href = LoginURL;
    },
    loadPast: function() {
      let vue = this;
      vue.pastRooms = getLocal("vxroompast",true) || [];
    },
    add2Past: function(name) {
      let vue = this;
      let arr = [ name ];
      if (!name) { return; }
      for (let i=0; i<9 && i<vue.pastRooms.length; i++) {
        if (vue.pastRooms[i] != name) {
          arr.push(vue.pastRooms[i]);
        }
      }
      vue.pastRooms = arr;
      setLocal("vxroompast",JSON.stringify(vue.pastRooms));
    },
  },
  computed: {
    currentUser: function() {
      return this.$user.get();
    },
    room: sync("room"),
    mydevice: sync("mydevice"),
    viewTitle: function() {
      return this.$route.meta.viewTitle;
    } 
  },
  data() {
    return {
      show_panel: false,
      debug: 0,
      is_mod: false,
      is_owner: false,
      dbell_ok: true,
      ctrl: { viewing: "",
              state:{pl:""},
              alert:{not_sil:true},
              privmode:false,
              can_join:false,
              can_view:false,
              enable_desk: false,
              script_active: false,
            },
      fatal: {
        alertCountDown: 0,
        alertMessage: "",
      },
      disable_notifications: false,
      canShowStats: false,
      nav_title: "",
      cur_room_name: "",
      show_msg_no_tracking: false,
      show_msg_tracking: false,
      show_cam_btn: false,
      video_off: false,
      tmp_cur_low: 0,
      tmp_max_low: 0,
      tmp_testkill: 0,
      unmute: false,
      eventid: null,

      avrefresh_in_progress: false,
      video_enabled: true,
      /* Only on request ask for video permission/enumerate */
      has_enumerated_video: false,
      enumerate_video: false,
      video_max: null,
      selected_video_group: null,
      video_groups: null,
      /* Immediately ask for audio permission/enumerate */
      has_enumerated_audio: false,
      enumerate_audio: true,
      selected_audio_group: [null,null],
      sel_audio_idx: 0,
      audio_groups: null,
      selected_video_source: null,
      video_sources: null,
      selected_audio_source: [null,null],
      audio_sources: null,
      selected_speaker_source: null,
      speaker_sources: null,
      enable_speaker_select: false,
      auto_start_capture: null,
      exit_listener: null,

      nav:{rname:"",
           nav:false,
           home:false,
           title: false,
           close_iframe: false,
           login: false,
           room_search: false,
           myroom: false,
           settings: false,
           mirror: false,
           aarec: false,
           unmute: false,
           stats: false,
           dropdown: false,
           adm: false,
           adm_acc: false,
           adm_users: false,
           back_toroom: false,
           back_hist: false,
           back_settings: false,
           goloc_cont: false,
           kvm: false,
           ss: false,
           cap_panel: false,
           cap_panel_download: false,
           aud_search: false,
           menu_debug: false,
           menu_arc: false,
           menu_newwindow: false,
           cast_ask_cb: null,
           },

       pastRooms: [],
    };
  }
};
</script>

<style lang="scss" scoped>
form label {
  color: #000;
}
</style>
